import { oz } from '@weft/utils';
import { ContactSchema } from '../../primitives';

export const CustomerContractsSchema = oz.array(ContactSchema).refine(data => data.filter(contact => contact.isPrimary).length <= 1, {
  message: 'There must be at most one primary contact.',
  path: ['isPrimary'],
});

export type CustomerContracts = oz.infer<typeof CustomerContractsSchema>;